module.exports = __webpack_public_path__ + "static/img/kuaisutongdao.46d208ba.png";